<ng-template #componentTemplate>
  <div class="fullscreen-container" [ngSwitch]="etat">
    <a href="#" (click)="retourVersAccueil($event)" class="bleu-caf ">
      <div class="d-block d-sm-block d-md-none bouton-retour cnaf-background1 cnaf-margin-mobile">
        <img alt="" src="/icfstatiquesangularappli/dist/images/burger_chevron_gauche_gris.png" />
        Retour
      </div>
    </a>
    <div class="col-sm-12 espacement" *ngSwitchCase="'loading'">
      <div class="progress">
        <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40"
          aria-valuemin="0" aria-valuemax="100">
          Chargement en cours...
        </div>
      </div>
    </div>
    <div class="col-sm-12 espacement" *ngSwitchCase="'error'">
      <div class="alert alert-danger" role="alert">
        <span class="glyphicon glyphicon-alert" aria-hidden="true"></span>
        <p class="inline-cnaf">Un incident technique s'est produit.
          <br aria-hidden="true">Merci de réessayer plus tard.
        </p>
      </div>
    </div>
    <div class="row" *ngSwitchCase="'loaded'">
      <div class="col-sm-12">
        <h2>Pour quel motif souhaitez-vous contacter
          votre Caf ?</h2>
        <a routerLink="/motifsdecontact/delaisdetraitement"
          class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
          Je me renseigne sur les délais de
          traitement des démarches
        </a>
        <a routerLink="/motifsdecontact/changementdesituation"
          class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
          Ma situation familiale ou professionnelle change
        </a>
        <a routerLink="/motifsdecontact/dettes" class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
          Je m’informe ou je rembourse une
          dette
        </a>
        <a *ngIf="boutonSaisonnierActuel" routerLink="/motifsdecontact/actualites"
          class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
          {{boutonSaisonnierActuel.titreDuBouton}}
        </a>
        <a routerLink="/motifsdecontact/autremotif" class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
          Autre motif
        </a>
      </div>
    </div>
  </div>
</ng-template>

<div>
  <ng-container *ngIf="isContexteMobile; else notFoundTemplate">
    <ng-container *ngTemplateOutlet="componentTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #notFoundTemplate>
  <div>
    <h2>Page introuvable </h2>
    <p>Cette page est accessible uniquement depuis l'application mobile.</p>
    <a href="#" class="btn btn-primary-cnaf espacement" (click)="retourVersAccueil($event)" >Retour vers l'accueil</a>
  </div>
</ng-template>